
import AddDaycare from "../pages/dayCare/AddDaycare";
import EditDaycare from "../pages/dayCare/EditDaycare";
import Login from "../layout/auth/Login";
import MainLayouts from "../layout/main/MainLayouts";
import DashboardAnalytics from "../pages/dashboard/DashboardAnalytics";
import DayCareList from "../pages/dayCare/DayCareList";
import ModuleList from "../pages/modules/ModuleList";
import SubscriptionList from "../pages/subscription/SubscriptionList";
import EnquiryList from "../pages/enquiry/EnquiryList";
import RelationType from "../pages/relation/RelationType";
import CategoryList from "../pages/category/CategoryList";
import CmsData from "../pages/cms/CmsData";
import AddCmsData from "../pages/cms/AddCmsData";
import EditCmsData from "../pages/cms/EditCmsData";
import PaymentHisory from "../pages/payment/PaymentHisory";

const routeCollection = [
    {
        path: "/login",
        element: <Login />,
    },

    {
        path: "/dashboard",
        element: <MainLayouts />,
        children: [
            {
                path: "/dashboard",
                element: <DashboardAnalytics />,
            },
            {
                path: "module",
                element: <ModuleList />,
            },
            {
                path: "daycare",
                element: <DayCareList />,
            },
              {
                path: "payment-history",
                element: <PaymentHisory />,
            },
            {
                path: "add-daycare",
                element: <AddDaycare />,
            },
            {
                path: "edit-daycare/:id",
                element: <EditDaycare />,
            },
            {
                path: "subscription",
                element: <SubscriptionList />,
            },
            {
                path: "enquiry",
                element: <EnquiryList />,
            },
            {
                path: "relation",
                element: <RelationType />,
            },
            {
                path: "category",
                element: <CategoryList />,
            },
            {
                path: "cms",
                element: <CmsData />,
            },

            {
                path: "add-cms/:cmdfor/:type",
                element: <AddCmsData />,
            },
            {
                path: "edit-cms/:cmdfor/:type/:id",
                element: <EditCmsData />,
            },

        ],

    }
];

export default routeCollection;
